import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ResourceCostMasterTab from './ResourceCostMasterTab';
import RevenueTab from './RevenueTab';
import RateMasterTab from './RateMasterTab';
import './ProjectFinancialMIS.css';

const page = {
  minHeight: 'auto',
  background: 'transparent',
  padding: '4px 0',
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontSize: '14px',
  color: '#0F172A',
  animation: 'fadeInUp 0.4s ease-out',
};

export default function ProjectFinancialMIS() {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get('tab') === 'revenue' ? 'revenue' : 'resourceCost'
  );

  return (
    <div style={page}>
      <div className="pfmis-shell">
        <div className="pfmis-heading">
          <h1>Project &amp; Financial MIS</h1>
          <p>Resource cost, revenue, and rate management</p>
        </div>

        {/* TAB NAVIGATION */}
        <div className="pfmis-tabs" aria-label="Project and Financial MIS sections">
          <button
            type="button"
            className={`pfmis-tab ${activeTab === 'resourceCost' ? 'active' : ''}`}
            aria-pressed={activeTab === 'resourceCost'}
            onClick={() => setActiveTab('resourceCost')}
          >
            Resource Cost Master
          </button>
          <button
            type="button"
            className={`pfmis-tab ${activeTab === 'revenue' ? 'active' : ''}`}
            aria-pressed={activeTab === 'revenue'}
            onClick={() => setActiveTab('revenue')}
          >
            Revenue
          </button>
          <button
            type="button"
            className={`pfmis-tab ${activeTab === 'rateMaster' ? 'active' : ''}`}
            aria-pressed={activeTab === 'rateMaster'}
            onClick={() => setActiveTab('rateMaster')}
          >
            Rate Master
          </button>
        </div>
      </div>

      {/* TAB CONTENT */}
      {activeTab === 'resourceCost' && <ResourceCostMasterTab />}
      {activeTab === 'revenue' && <RevenueTab />}
      {activeTab === 'rateMaster' && <RateMasterTab />}
    </div>
  );
}
